import React from "react";
import HealthIndicator from "../HealthIndicator";
import {
  BATTERY_BARS,
  batteryGaugeLabel,
  batteryGaugeLevel,
  hasBatteryGauge,
} from "../../helpers/battery";
import styles from "./BatteryBars.module.scss";

/*
 * Battery as four bars, worked out by the server from the charge the pack has
 * used (battery_bars). A device the battery job has not measured yet has no
 * bars, and keeps the voltage-based percentage it showed before.
 */
export default function BatteryBars({ battery, bars, compact = false }) {
  if (!hasBatteryGauge(bars)) {
    return battery ? (
      <HealthIndicator
        title="Battery level"
        icon="battery_full"
        value={`${battery}%`}
      />
    ) : null;
  }

  const label = batteryGaugeLabel(bars);
  return (
    <div
      className={[
        styles.wrap,
        styles[batteryGaugeLevel(bars)],
        compact ? styles.compact : "",
      ].join(" ")}
      title={label}
      role="img"
      aria-label={label}
    >
      <div className={styles.battery}>
        {Array.from({ length: BATTERY_BARS }, (_, i) => (
          <span key={i} className={i < bars ? styles.lit : styles.segment} />
        ))}
      </div>
    </div>
  );
}
